import React from 'react';
import config from '../../../config/config';

const ContactNote: React.VFC<{ className: string }> = ({ className }) => (
  <div className={className}>
    Please{' '}
    <a
      href={`${config.url}/personal-investing/help/contact/index.html`}
      rel="noopener noreferrer"
      target="_blank"
    >
      contact us
    </a>{' '}
    to discuss the options available to you for placing a redemption.
  </div>
);

export default ContactNote;
